import { Pagination, PaginationControls } from '@common/types/pagination';

interface UsePaginationControlsProps {
    itemCount: number;
    pageIndex: number;
    pageSize: number;
    pageSizes: number[];
    onPaginationChange?: (pagination: Pagination) => void;
}

export const usePaginationControls = ({
    itemCount,
    pageIndex,
    pageSize,
    pageSizes,
    onPaginationChange,
}: UsePaginationControlsProps): PaginationControls => {
    const pageCount = Math.max(1, Math.ceil(itemCount / pageSize));

    const hasNextPage = pageIndex + 1 < pageCount;
    const hasPreviousPage = pageIndex > 0;

    const nextPage = () => {
        if (hasNextPage) {
            onPaginationChange?.({ pageIndex: pageIndex + 1, pageSize });
        }
    };

    const previousPage = () => {
        if (hasPreviousPage) {
            onPaginationChange?.({ pageIndex: pageIndex - 1, pageSize });
        }
    };

    const handleSetPageIndex = (newPageIndex: number) => {
        if (newPageIndex >= 0 && newPageIndex < pageCount) {
            onPaginationChange?.({ pageIndex: newPageIndex, pageSize });
        }
    };

    const handleSetPageSize = (newPageSize: number) => {
        if (pageSizes.includes(newPageSize)) {
            onPaginationChange?.({ pageSize: newPageSize, pageIndex });
        }
    };

    return {
        itemCount,
        pageIndex,
        hasNextPage,
        hasPreviousPage,
        pageCount,
        pageSize,
        pageSizes,

        nextPage,
        previousPage,
        setPageIndex: handleSetPageIndex,
        setPageSize: handleSetPageSize,
    };
};
